import { FunctionComponent, ReactNode } from "react";

import { format } from "date-fns";

import { Tooltip } from "@/components/Tooltip/Tooltip";

interface SentDetailsTooltipProps {
	sentByUserName?: string;
	sentAt?: Date;
	sentWithEmail?: string;
	children: ReactNode;
}

export const SentDetailsTooltip: FunctionComponent<SentDetailsTooltipProps> = ({
	sentByUserName,
	sentAt,
	sentWithEmail,
	children,
}) => {
	const hasDetails = !!sentByUserName || !!sentAt;

	if (!hasDetails) {
		return <>{children}</>;
	}

	return (
		<Tooltip
			content={
				<div className="flex flex-col gap-1 text-xs text-text-meta">
					{sentByUserName && <span>Sent by: {sentByUserName}</span>}
					{sentAt && <span>At: {format(sentAt, "HH:mm dd.MM.yyyy")}</span>}
					{sentWithEmail && <span>Via: {sentWithEmail}</span>}
				</div>
			}
			direction="bottom"
		>
			{children}
		</Tooltip>
	);
};
